import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { useFormikContext } from 'formik';
import { DatePicker } from '@agconnections/grow-ui';
import sortDates from 'screens/Integrations/helpers/sortDates';
import { arrayObjectEquals } from 'helpers/arrayHelpers';

const CropSeasonDateRange = ({
  className,
  initialStartDate,
  initialEndDate,
  cropSeasons,
  isRequired,
  disabled
}) => {
  const { values, setFieldValue } = useFormikContext();
  const { startDate, endDate } = useMemo(() => {
    const { cropSeasonStartDate, cropSeasonEndDate } = sortDates(
      values.selectedCropSeasons
    );
    if (
      initialStartDate &&
      initialEndDate &&
      cropSeasons &&
      (initialStartDate !== cropSeasonStartDate ||
        initialEndDate !== cropSeasonEndDate) &&
      arrayObjectEquals(cropSeasons, values.selectedCropSeasons)
    ) {
      return {
        startDate: initialStartDate,
        endDate: initialEndDate
      };
    }
    return sortDates(values.selectedCropSeasons);
  }, [
    values.selectedCropSeasons,
    initialStartDate,
    initialEndDate,
    cropSeasons
  ]);

  useEffect(() => {
    setFieldValue('cropSeasonStartDate', startDate);
    setFieldValue('cropSeasonEndDate', endDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  return (
    <div className={className}>
      <GrowUIFormField
        label={isRequired ? 'Start Date *' : 'Start Date'}
        name="cropSeasonStartDate"
        dates={startDate}
        control={DatePicker}
        disabled={disabled || !values?.selectedCropSeasons?.length}
      />
      <GrowUIFormField
        label={isRequired ? 'End Date *' : 'End Date'}
        name="cropSeasonEndDate"
        dates={endDate}
        control={DatePicker}
        disabled={disabled || !values?.selectedCropSeasons?.length}
      />
    </div>
  );
};

CropSeasonDateRange.propTypes = {
  className: PropTypes.string,
  initialStartDate: PropTypes.instanceOf(Date),
  initialEndDate: PropTypes.instanceOf(Date),
  cropSeasons: PropTypes.arrayOf(PropTypes.object),
  isRequired: PropTypes.bool.isRequired,
  disabled: PropTypes.bool
};

CropSeasonDateRange.defaultProps = {
  className: '',
  initialStartDate: null,
  initialEndDate: null,
  cropSeasons: null,
  disabled: false
};

export default CropSeasonDateRange;
